module.exports = __webpack_public_path__ + "media/images/logo-588d75517f2df06b2f6b74ddd28abde1.svg";